import security from '@/common/security'
import menuItems from '@/common/menu'
import store from '@/store'

import {
  GET_MENU_OPEN,
  SET_MENU_OPEN,
  GET_SEARCH_QUERY,
  SET_SEARCH_QUERY,
  GET_FILTERED_MENU_ITEMS, NAV_SET_MENU_OPEN
} from './nav.types'

function handleDocumentClick (event) {
  // See if there is a parent with the id #acm-nav-menu, if
  // so, it means that the user clicked somewhere on the
  // main menu, if not, it means the user clicked somewhere
  // outside the main menu.
  const mainMenu = event.target.closest('#acm-nav-menu')
  const mainMenuBtn = event.target.closest('#acm-main-menu-btn')
  if (mainMenu === null && mainMenuBtn === null) {
    // Close the menu since the user clicked away from it.
    store.commit(NAV_SET_MENU_OPEN, false)
  }
}

export const state = {
  menuOpen: false,
  searchQuery: ''
}

export const mutations = {
  [SET_MENU_OPEN] (state, open) {
    state.menuOpen = open

    if (state.menuOpen) {
      document.addEventListener('click', handleDocumentClick)
    } else {
      document.removeEventListener('click', handleDocumentClick)
    }
  },

  [SET_SEARCH_QUERY] (state, query) {
    state.searchQuery = query
  }
}

const getters = {
  [GET_MENU_OPEN]: state => {
    return state.menuOpen
  },

  [GET_SEARCH_QUERY]: state => {
    return state.searchQuery
  },

  /**
   * Returns a filtered list of menu items based on the current
   * search query and user's access rights.
   *
   * @param Object state
   *
   * @returns Array
   */
  [GET_FILTERED_MENU_ITEMS]: state => {
    let results = []
    // Convert to lowercase and remove multiple spaces/tabs, etc.
    const searchQuery = state.searchQuery.toLowerCase().replace(/\s\s+/g, ' ')

    if (searchQuery !== '') {
      for (let key in menuItems) {
        if (menuItems.hasOwnProperty(key)) {
          if (menuItems[key].searchTags.find(tag => tag.includes(searchQuery))) {
            if (menuItems[key].security.check) {
              if (security.can(menuItems[key].security.permission, menuItems[key].security.action)) {
                results.push(menuItems[key])
              }
            } else {
              results.push(menuItems[key])
            }
          }
        }
      }
    }

    return results
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/navigation/nav.js